// extracted by mini-css-extract-plugin
export default {"container":"C_-z"};